module.exports = __webpack_public_path__ + "img/Qrcode_1.e4b9c9a8.png";